<template lang="pug">
v-container(fluid fill-height class="tw-h-screen")
  v-row(align="center" justify="center")
    v-col(cols="12" sm="8" md="6" lg="5")
      v-card(class="pa-8 text-center" elevation="2")
        v-card-title(class="justify-center text-h5") Verify your email address
        v-card-text
          p Check your inbox for the verification email before choosing a subscription.
          p(v-if="sent") A new verification email has been sent.
        v-card-actions(class="justify-center")
          v-btn(color="primary" :loading="sending" @click="sendVerification") Send verification email
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  name: 'VerificationRequired',
  data() {
    return {
      sending: false,
      sent: false,
    };
  },
  methods: {
    async sendVerification() {
      this.sending = true;
      try {
        await AuthService.sendVerification();
        this.sent = true;
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
